import { gql } from '@apollo/client';

const REVIEW_FIELDS = `
  statusCode
  message
  data {
    customerId
    letterStatus
    letterEnvelopeId
    signedAt
    verifierName
    verifierEmail
    reviewStatus
    reviewedBy
    reviewedAt
    reviewNote
    investmentId
    agreementEnvelopeId
    ace
    registry
    registryExplorerUrl
    canReview
    reason
    rejections {
      envelopeId
      signedAt
      verifierName
      verifierEmail
      reviewedBy
      reviewedAt
      reviewNote
    }
  }
`;

/**
 * An investor's accreditation for the admin's Approve/Deny: the letter, the decision, the
 * on-chain parts (written only after an approval, checked live) and any earlier denied letters.
 * canReview is true once the letter and an agreement are signed.
 */
export const GET_ACCREDITATION_REVIEW = gql`
  query GetAccreditationReview($customerId: String!) {
    getAccreditationReview(customerId: $customerId) {
      ${REVIEW_FIELDS}
    }
  }
`;

/**
 * decision: APPROVED | DENIED.
 * APPROVED records the accreditation on-chain; funding opens once that is confirmed.
 * DENIED writes nothing on-chain, emails the investor and sends them back to send a new letter to their verifier.
 */
export const REVIEW_ACCREDITATION = gql`
  mutation ReviewAccreditation($customerId: String!, $decision: String!, $note: String) {
    reviewAccreditation(customerId: $customerId, decision: $decision, note: $note) {
      ${REVIEW_FIELDS}
    }
  }
`;
